import React from 'react';
import styled from 'styled-components';
import closeIcon from '../../assets/icons/close.svg';

interface PrivacyPolicyPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isFullPage?: boolean;
}

const PrivacyPolicyPopup: React.FC<PrivacyPolicyPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isFullPage = false,
}) => {
  if (!isOpen) return null;

  return (
    <Overlay $isFullPage={isFullPage}>
      <PopupContainer $isFullPage={isFullPage}>
        <Contents>
          <TitleContainer>
            <Title>개인정보 수집 및 이용</Title>
            <CloseButton onClick={onClose}>
              <img src={closeIcon} alt="Close" />
            </CloseButton>
          </TitleContainer>
          <PolicyText>
            (주)퍼즐코퍼레이션은 제휴 문의 사항 등록 시, 최소 범위에서 아래와 같이 개인정보를 수집・이용합니다.
            {'\n\n'}
            <strong>1. 수집하는 개인정보 항목{'\n'}</strong>
            소속, 이름, 전자우편 주소
            {'\n\n'}
            <strong>2. 수집 및 이용 목적{'\n'}</strong>
            제휴•문의 사항 접수 및 처리결과 회신
            {'\n\n'}
            <strong>3. 개인정보의 이용 기간{'\n'}</strong>
            목적 달성 후, 해당 개인정보를 바로 파기
            {'\n\n'}
            위 개인정보 수집•이용에 대한 동의를 거부할 권리가 있습니다. 다만 동의를 거부하는 경우 제휴•문의 사항 등록이 제한될 수 있습니다.
          </PolicyText>
        </Contents>
        <ButtonContainer>
          <CancelButton onClick={onClose}>취소</CancelButton>
          <ConfirmButton onClick={onConfirm}>확인</ConfirmButton>
        </ButtonContainer>
      </PopupContainer>
    </Overlay>
  );
};

const Overlay = styled.div<{ $isFullPage?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  ${({ $isFullPage }) => $isFullPage && `
    background: #fff;
    z-index: 2000;
    justify-content: flex-start;
    align-items: flex-start;
    @media (max-width: 768px) {
      padding: 0;
    }
  `}
`;

const PopupContainer = styled.div<{ $isFullPage?: boolean }>`
  background: #FFFFFF;
  border-radius: 20px;
  padding: 50px 50px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  margin: 20px;
  max-width: 1000px;
  
  @media (max-width: 1919px) {
    max-width: 800px;
  }

  ${({ $isFullPage }) => $isFullPage && `
    border-radius: 0;
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 32px 16px 24px;
    @media (max-width: 768px) {
      padding: 24px 8px 16px;
    }
  `}
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

const Title = styled.h2`
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 32px;
  line-height: 1.4375em;
  letter-spacing: -0.01em;
  color: #1D1D1D;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  img {
    width: 24px;
    height: 24px;
    filter: brightness(0);
  }
`;

const PolicyText = styled.p`
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 16px;
  line-height: 1.625em;
  letter-spacing: -0.01em;
  color: #1D1D1D;
  white-space: pre-wrap;
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const Button = styled.button`
  font-family: 'Pretendard';
  font-size: 16px;
  line-height: 1.75em;
  letter-spacing: -0.01em;
  padding: 16px 30px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`;

const CancelButton = styled(Button)`
  background: transparent;
  border: 1px solid #DCDCDC;
  color: #1D1D1D;
  font-weight: 500;
  min-width: 160px;
  
  &:hover {
    background: #f5f5f5;
  }
`;

const ConfirmButton = styled(Button)`
  background: #FF4F00;
  border: none;
  color: #FFFFFF;
  font-weight: 700;
  min-width: 160px;
  
  &:hover {
    background: #e64600;
  }
`;

export default PrivacyPolicyPopup;